<script>
import ImageWrapper from '@/components/atoms/ImageWrapper'
export default {
    name: 'TagImage',
    components: { ImageWrapper },
    props: {
        value: null,
        tag: null,
        disabled: Boolean,
    },
    computed: {
        locale() {
            return this.$store.getters['locale']
        },
        active() {
            return this.tag?.slug === this.value
        },
    },
    methods: {
        onClick() {
            if (!this.disabled) this.$emit('input', !this.active ? this.tag.slug : undefined)
        },
    },
}
</script>

<template lang="pug">
.tag(v-if="tag" @click="onClick" :class="{'active': active, 'disabled': disabled}")
    image-wrapper.tag-image(:src="tag.image" :tag="$t('tags.tag', {name: tag.name_token})")
    span.text-sm.font-weight-semibold {{tag.name_token}}
    //span.text-sm {{tag.translations[locale].name}}
</template>
